"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNextBestPropositionQueryRequestBase = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const enums_1 = require("../enums");
class GetNextBestPropositionQueryRequestBase extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)({ name: 'profile_id' }),
    (0, base_models_1.Docs)({ example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7', description: 'Profile ID' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestPropositionQueryRequestBase.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({ example: base_models_1.Brand.ESSENT, description: 'Brand the offer is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestPropositionQueryRequestBase.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Channel)),
    (0, base_models_1.Docs)({ example: enums_1.Channel.MIJN, description: 'Channel the offer is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestPropositionQueryRequestBase.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.PropositionDuration), { each: true }),
    (0, base_models_1.Docs)({ example: [enums_1.PropositionDuration.FLEX], description: 'Offer duration.' }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestPropositionQueryRequestBase.prototype, "durations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType), { each: true }),
    (0, class_transformer_1.Expose)({ name: 'segment_types' }),
    (0, base_models_1.Docs)({ example: [base_models_1.SegmentType.SOHO], description: 'Offer segment types' }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestPropositionQueryRequestBase.prototype, "segmentTypes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.ProductType), { each: true }),
    (0, class_transformer_1.Expose)({ name: 'product_types' }),
    (0, base_models_1.Docs)({ example: [enums_1.ProductType.ELECTRICITY], description: 'Offer product types' }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestPropositionQueryRequestBase.prototype, "productTypes", void 0);
exports.GetNextBestPropositionQueryRequestBase = GetNextBestPropositionQueryRequestBase;
